import { render } from "./backup-settings.vue?vue&type=template&id=5900f4c4"
import script from "./backup-settings.vue?vue&type=script&lang=js"
export * from "./backup-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__